module.exports = __webpack_public_path__ + "img/logo.183de1f1.png";